import React, { useContext, useEffect, useState } from 'react';
import styled, { css } from 'styled-components';

import { colors, media } from '../../../utils/styles';
import { Footer, Back, SubmitButton } from '../';
import { QuizContext } from '../../../store/quiz';

export const Select = ({ data }) => {
  const {
    store: { submitAnswer, prevStep, answers, quizLog },
  } = useContext(QuizContext);

  const {
    items,
    primary: { type, question },
  } = data;

  const [selectedValues, setSelectedValues] = useState([]);

  useEffect(() => {
    setSelectedValues(answers[question] || []);
  }, [question, answers]);

  const onClick = (answer, points = 0, product = null) => {
    if (type === 'single-select') {
      return setSelectedValues([{ text: answer, points, product }]);
    }

    if (selectedValues.find(value => value.text === answer)) {
      return setSelectedValues(prevValues => prevValues.filter(val => val.text !== answer));
    }

    if (answer === 'None') {
      return setSelectedValues([{ text: answer, points, product }]);
    }

    setSelectedValues(prevValues => {
      const filteredPrevValues = prevValues.filter(value => value.text !== 'None');
      return [...filteredPrevValues, { text: answer, points, product }];
    });
  };

  const onSubmit = () => {
    submitAnswer(question, selectedValues);
    quizLog(`Answer_${selectedValues.map(value => value.text).join(' | ')}`, question);
  };

  return (
    <Wrap>
      <Heading>{question}</Heading>
      <Buttons>
        {items.map((item, index) => {
          const isSelected = selectedValues.find(value => value.text === item.answer_text);
          return (
            <Column key={index}>
              <Button
                onClick={() =>
                  onClick(item.answer_text, item.points || 0, item.related_product?.uid)
                }
                $selected={isSelected}
              >
                {item.answer_text}
                {isSelected && (
                  <Icon
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="8" cy="8" r="8" />
                    <path
                      d="M5 8.46L6.78437 10L10.5 6.5"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </Icon>
                )}
              </Button>
            </Column>
          );
        })}
      </Buttons>
      <Footer>
        <div>
          <SubmitButton disabled={!selectedValues.length} onClick={onSubmit}>
            Continue
          </SubmitButton>
        </div>
        <Back onBack={prevStep} />
      </Footer>
    </Wrap>
  );
};

const Icon = styled.svg`
  position: absolute;
  top: -7px;
  right: -8px;
  circle {
    fill: ${({ theme }) => theme.primary};
  }
`;

const Buttons = styled.div`
  display: flex;
  margin: -12px -12px 28px;
  justify-content: center;
  flex-wrap: wrap;
  ${media.phone} {
    margin: 0;
  }
`;

const Column = styled.div`
  padding: 12px;
  width: 33.33%;
  ${media.phone} {
    padding: 0;
    width: 100%;
    margin: 0 0 16px;
  }
`;

const Button = styled.button`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 65px;
  background: #f8fafb;
  color: #000000;
  border-radius: 5px;
  border: 2px solid transparent;
  font-weight: bold;
  font-size: 14px;
  transition: none;
  &:hover {
    border-color: ${({ theme }) => theme.primary};
  }
  ${p =>
    p.$selected &&
    css`
      border-color: ${({ theme }) => theme.primary};
      color: ${({ theme }) => theme.primary};
    `}
`;

const Heading = styled.h1`
  font-weight: bold;
  font-size: 32px;
  margin: 0 auto 48px;
  width: 580px;
  max-width: 100%;
  line-height: 43px;
  text-transform: capitalize;
  ${media.phone} {
    margin: 0 0 24px;
    font-size: 28px;
    line-height: 36px;
  }
`;

const Wrap = styled.div`
  text-align: center;
  width: 100%;
  ${media.phone} {
    display: flex;
    flex-direction: column;
  }
`;
